import { IMyCareersPrioritize } from "interfaces/OnbaordingInterface";

interface HorizontalCareerItem {
  task: IMyCareersPrioritize;
  index: number;
  onboardingSorted?: boolean;
}

const HorizontalCareerItem = ({
  task,
  index,
  onboardingSorted,
}: HorizontalCareerItem) => {
  return (
    <div className="flex items-center w-full gap-2.5" title={task.name}>
      {task.category !== "discard" && !onboardingSorted && (
        <span className="flex items-center justify-center shrink-0 rounded-full bg-brand w-5 h-5 text-white text-[10px] font-bold">
          {index}
        </span>
      )}
      <img
        src={task.icon_url}
        alt={task.name}
        width="28"
        height="28"
        className="rounded-full shrink-0 border border-border object-cover"
      />
      <span className="text-body-sm-emphasis text-text-heading truncate">{task.name}</span>
    </div>
  );
};

export default HorizontalCareerItem;
